import Layout from '@layout/Index'

export const auditIntern = [
  {
    path: '/audit-intern',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "audit-intern-table" */ './pages/AuditInternTable.vue'),
        meta: {
          title: '实习生账号列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "audit-intern-create" */ './pages/AuditInternCreateForm.vue'),
        meta: {
          title: '新增实习生账号',
          pageType: 'create',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "audit-intern-form" */ './pages/AuditInternEditForm.vue'),
        meta: {
          title: '修改实习生账号',
          pageType: 'update',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "audit-intern-detail" */ './pages/AuditInternDetail.vue'),
        meta: {
          title: '实习生账号详情',
        },
      },
      {
        path: 'cronjob',
        component: () => import(/* webpackChunkName: "audit-intern-cronjob" */ './pages/AuditInternJobsTable.vue'),
        meta: {
          title: '实习生批量任务',
        },
      },
      {
        path: 'monthly-onduty-table',
        component: () => import(/* webpackChunkName: "monthly-onduty-table" */ './pages/InternMonthlyOnDutyTable.vue'),
        meta: {
          title: '实习生月度出勤统计',
        },
      },
      {
        path: 'attendance-plan-monthly',
        component: () => import(/* webpackChunkName: "attendance-plan-monthly" */ './pages/InternAttendancePlanMonthly.vue'),
        meta: {
          title: '考勤计划月度列表',
        },
      },
      {
        path: 'attendance-plan-detail/:internUserId/:planMonth',
        component: () => import(/* webpackChunkName: "attendance-plan-detail" */ './pages/InternAttendancePlanDetail.vue'),
        meta: {
          title: '考勤计划明细',
        },
      },
      {
        path: 'daily-onduty-table',
        component: () => import(/* webpackChunkName: "daily-onduty-table" */ './pages/InternDailyOnDutyTable.vue'),
        meta: {
          title: '实习生出勤明细',
        },
      },
      {
        path: 'attendance-project-target/table',
        component: () => import(/* webpackChunkName: "ProjectAttendanceTargetTable" */ './pages/attend-notify/ProjectAttendanceTargetTable.vue'),
        meta: {
          title: '项目出勤设置',
        },
      },
      {
        path: 'attendance-notify-cfg-table',
        component: () => import(/* webpackChunkName: "attendance-notify-cfg-table" */ './pages/attend-notify/InternAttendanceNotifyCfgTable.vue'),
        meta: {
          title: '出勤日历提醒通知列表',
        },
      },
      {
        path: 'attendance-notify-cfg/create',
        component: () => import(/* webpackChunkName: "attendance-notify-cfg-create" */ './pages/attend-notify/InternAttendanceNotifyCfgForm.vue'),
        meta: {
          title: '新增出勤日历提醒通知',
        },
      },
      {
        path: 'attendance-notify-cfg/update/:id',
        component: () => import(/* webpackChunkName: "attendance-notify-cfg-edit" */ './pages/attend-notify/InternAttendanceNotifyCfgForm.vue'),
        meta: {
          title: '修改出勤日历提醒通知',
        },
      },
      {
        path: 'attendance-notify-history/:refId/table',
        component: () => import(/* webpackChunkName: "attendance-notify-cfg-edit" */ './pages/attend-notify/InternAttendanceNotifySentHistoryTable.vue'),
        meta: {
          title: '出勤日历提醒通知发送记录',
        },
      },
      {
        path: 'performance',
        component: () => import(/* webpackChunkName: "audit-intern-performance" */ './pages/InternAuditPerformanceTable.vue'),
        meta: {
          title: '审单绩效统计',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/audit-intern/audit-intern.route.js